export default __webpack_public_path__ + "static/media/aga.5c528988.png";